export const share = async ({
    title = document.title,
    text = "",
    url = window.location.href,
} = {}) => {
    if (typeof navigator === "undefined") return;

    // Native device share
    if (navigator.share) {
        try {
            await navigator.share({ title, text, url });
            return;
        } catch {
            return;
        }
    }

    // Fallback (desktop)
    try {
        await navigator.clipboard.writeText(url);
        alert("Link copied to clipboard");
    } catch (err) {
        console.error("Copy failed", err);
    }
};
